import { memo, useMemo } from 'react';
import FooterMenuActions from './FooterMenuActions';
import useCameraFooterActions from '../../../MediaSection/hooks/useCameraFooterActions';
import styles from '../CameraStreamFooter.module.css';

const CameraStreamFooterActions = ({
    isPTZCamera,
    videoWallCameras,
    togglePTZ,
    isPTZOn,
    fullZoomIn,
    fullZoomOut,
    ptzRequestStatus,
    isCameraFocused,
    isAudioAvailable,
    audioEnabled,
    isCameraActive,
    onToggleAudio,
    enableDemoAudioFile,
    camVideoId,
    camId,
    camConfig,
    isTransactionPage,
    isDisabledSnapshot,
    onTakeSnapshot,
    onFaceMatch,
    rotation,
    expandedCamId,
    isMtxDirect,
    refreshVideoStreamHandler,
    hardRefreshVideoStreamHandler,
    isFullScreenRequested,
    openDialogHandler,
    footerMode,
    hasCameraIssues,
    clickHandlerCameraBugIcon,
    footerItemsStyle,
    isCameraFreezed,
    transactionId,
    visibleCameraIds,
    openWindowVideoIdOutput,
    isStreamTestPage,
}) => {
    const snapshotTooltipTitle = useMemo(() => {
        if (isDisabledSnapshot) return "Can't snapshot loading cameras";
        return (
            <div className={styles['tooltip--snapshot']}>
                <span>
                    <strong>Ctrl + click</strong> to download instantly
                </span>
                <span>
                    Snapshot <strong>[Alt + S]</strong>
                </span>
                <span>
                    Snapshot all <strong>[Alt + Shift + S]</strong>
                </span>
            </div>
        );
    }, [isDisabledSnapshot]);

    const { visibleActions, menuOptions } = useCameraFooterActions({
        isPTZCamera,
        videoWallCameras,
        togglePTZ,
        isPTZOn,
        fullZoomIn,
        fullZoomOut,
        ptzRequestStatus,
        isCameraFocused,
        isAudioAvailable,
        audioEnabled,
        isCameraActive,
        onToggleAudio,
        enableDemoAudioFile,
        camVideoId,
        camId,
        camConfig,
        isTransactionPage,
        isDisabledSnapshot,
        onTakeSnapshot,
        onFaceMatch,
        rotation,
        expandedCamId,
        isMtxDirect,
        refreshVideoStreamHandler,
        hardRefreshVideoStreamHandler,
        isFullScreenRequested,
        openDialogHandler,
        footerMode,
        hasCameraIssues,
        clickHandlerCameraBugIcon,
        footerItemsStyle,
        isCameraFreezed,
        snapshotTooltipTitle,
        transactionId,
        visibleCameraIds,
        openWindowVideoIdOutput,
        isStreamTestPage,
    });

    return (
        <div className={styles['tc-cs-footer-actions']}>
            {visibleActions.map((action) => (
                <div key={action.key} className={action.isWrapper ? '' : footerItemsStyle}>
                    {action.component}
                </div>
            ))}

            <FooterMenuActions menuOptions={menuOptions} className={footerItemsStyle} />
        </div>
    );
};

export default memo(CameraStreamFooterActions);
